<lib-call-to-action *ngIf="show" class="opt-in">
  <h2>Firm Management Setup: Testing Only</h2>
  <button mat-flat-button color="primary" (click)="setupManageFirm()">Manage Firm</button>
</lib-call-to-action>
